import React, { useState, useEffect } from "react";
import UserTables from "../components/UserTables";

import { toast } from "react-toastify";
import api from "../../utilis/api";

const ITEMS_PER_PAGE = 10;

const Users = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const handlePageChange = (page) => setCurrentPage(page);

  // Fetch users once
  const getUsers = async () => {
    try {
      const res = await api.get("/auth/users"); // Adjust endpoint
      if (res?.data?.data) {
        setData(res.data.data.user || []);
      }
    } catch (error) {
      toast.error(error?.message || "Error fetching users");
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  // Slice data for current page
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const pagedData = data.slice(startIndex, endIndex);

  return (
    <div className="flex flex-col w-full gap-4">
      {/* Header */}
      <div className="bg-gray-700 p-3 w-full">
        <h1 className="font-bold text-[1.3rem]">Manage Users</h1>
      </div>

      {/* Table */}
      <div className="p-2 w-full bg-gray-700">
        <UserTables
          data={pagedData}
          currentPage={currentPage}
          totalPages={Math.ceil(data.length / ITEMS_PER_PAGE)}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default Users;
